
import { v4 as uuidv4 } from 'uuid';
import FieldNames from '../defaults/FieldNames.json';
import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import Request from './request';
import GeneralService from './GeneralService';
import { getBaseFilterString } from '../utils/QueryHelper';
import IDService from './IDService';
import { getSaveableDate } from '../utils/DateHelper';
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from '../utils/ReduxHelper';

const GroupingService = {
  getAllGroupItemsByGroupIds: function (ids)
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        let idArr = ids.join(", ");
        const whereClause = `((${FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID} IN (${idArr})))`;
        const queryObject = new Query({
            where: `(${whereClause})`,
            outFields: "*",
            orderByFields: FieldNames.treatmentActivityGroupItems.id
        });

        return query.executeQueryJSON(rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId, queryObject).then(results => {
          let attr;
          if(results.features){
            attr = results.features.map((eaAttr) => eaAttr.attributes);
          }
          return attr;
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    getAllGroupItemsForFeatures: async function (joinIDs, joinFeature)
    {
      const rootServiceUrl = getAttributeServiceUrl();
      const config = getAppConfig();
      const groupItemsOutFields = [
        FieldNames.treatmentActivityGroupItems.globalID,
        FieldNames.treatmentActivityGroupItems.sequenceNumber,
        FieldNames.treatmentActivityGroupItems.isArchived,
        FieldNames.treatmentActivityGroupItems.createdBy,
        FieldNames.treatmentActivityGroupItems.createdDate,
        FieldNames.treatmentActivityGroupItems.geometryType,
        FieldNames.treatmentActivityGroupItems.id,
        FieldNames.treatmentActivityGroupItems.joinID,
        FieldNames.treatmentActivityGroupItems.joinFeature,
        FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID,
        FieldNames.treatmentActivityGroupItems.treatmentActivityGroupID,
        FieldNames.treatmentActivityGroupItems.objectID
      ];
      const groupOutFields = [
        FieldNames.treatmentActivityGroups.globalID,
        FieldNames.treatmentActivityGroups.isArchived,
        FieldNames.treatmentActivityGroups.createdBy,
        FieldNames.treatmentActivityGroups.createdDate,
        FieldNames.treatmentActivityGroups.id,
        FieldNames.treatmentActivityGroups.treatmentActivityGroupName,
        FieldNames.treatmentActivityGroups.objectID
      ];
      try
      {
        let finalGroups = {
          Groups: [],
          GroupItems: []
        };

        if(!joinIDs || joinIDs.length < 1)
        {
          return new Promise((resolve,reject) => {
            resolve(finalGroups);
          });
        }

        let allGroupItemResults = [];
        const numberToTakeEachTime = 2000;
        let startIndex = 0;
        let hasMoreRecords = true;
        let results = "";
        // let entityTypeClause = `(EntityType = '${entityTypeVal}')`;

        while(hasMoreRecords){
          try{
            let endIndex = startIndex + numberToTakeEachTime;
            let entityIdBatch = [];
            entityIdBatch = joinIDs.slice(startIndex, endIndex);
            let entityIdBatchJoined = entityIdBatch?.join(",");
            let batchWhere = `(${FieldNames.treatmentActivityGroupItems.joinID} IN (${entityIdBatchJoined}) AND (${FieldNames.treatmentActivityGroupItems.joinFeature} = '${joinFeature}'))`;
  
            const queryObject = new Query({
              where: batchWhere,
              orderByFields: "OBJECTID DESC",
              outFields: groupItemsOutFields,
              returnGeometry: false,
              num: numberToTakeEachTime
            });

            results = await GeneralService.queryCall(rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId, queryObject);
            if(results && results.length > 0){
              allGroupItemResults.push(results)
            }
          } catch(e){
            throw e;
          }
          hasMoreRecords = joinIDs.length > (startIndex + numberToTakeEachTime);
          startIndex += numberToTakeEachTime;
        }

        const allGroupItemResultsFlattened = (allGroupItemResults != null && allGroupItemResults.length > 0) ? allGroupItemResults.flat() : [];
        if(allGroupItemResultsFlattened &&
          allGroupItemResultsFlattened.length && allGroupItemResultsFlattened.length > 0)
        {
          let groupItems = allGroupItemResultsFlattened;
          let groupIds = [];
          allGroupItemResultsFlattened.forEach(eaGroupItem => {
            if(!groupIds.includes(eaGroupItem[FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID])){
              groupIds.push(eaGroupItem[FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID]);
            }
          })
          let allGroupResults = [];
          startIndex = 0;
          hasMoreRecords = true;
          results = "";
  
          if(groupIds && groupIds.length)
          {
            while(hasMoreRecords){
              try{
                let endIndex = startIndex + numberToTakeEachTime;
                let groupIdBatch = [];
                groupIdBatch = groupIds.slice(startIndex, endIndex);
                let groupIdBatchJoined = groupIdBatch?.join(",");
                let groupBatchWhere = `(ID IN (` + groupIdBatchJoined + "))";
      
                const groupQueryObject = new Query({
                  where: groupBatchWhere,
                  outFields: groupOutFields,
                  orderByFields: "OBJECTID DESC",
                  returnGeometry: false,
                  num:numberToTakeEachTime
                });
    
                results = await GeneralService.queryCall(rootServiceUrl + "/" + config.treatmentActivityGroup[config.env].layerId, groupQueryObject);
                if(results && results.length > 0){
                  allGroupResults.push(results)
                }
              } catch(e){
                throw e;
              }
              hasMoreRecords = groupIds.length > (startIndex + numberToTakeEachTime);
              startIndex += numberToTakeEachTime;
            }
  
            const allGroupResultsFlattened = (allGroupResults != null && allGroupResults.length > 0) ? allGroupResults.flat() : [];
            if(allGroupResultsFlattened && allGroupResultsFlattened.length > 0){
              const groups = allGroupResultsFlattened;
              let allGroupIds = [];
              if(groups && groups.length > 0){
                allGroupIds = groups.map((eaAttr) => eaAttr[FieldNames.treatmentActivityGroups.id]);
              }
              let remainingGroupItems = [];
              if(allGroupIds && groupItems){
                remainingGroupItems = groupItems.filter(x => allGroupIds.includes(x[FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID]));
              }
              finalGroups.Groups = groups;
              finalGroups.GroupItems = remainingGroupItems;
              return finalGroups;
            } else {
              return finalGroups;
            }
          }
          else
          {
            return finalGroups;
          }
        }
        else
        {
          return finalGroups;
        }
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    getAllGroupItemsForFeaturesByIds: async function (joinFeature, featureIDs)
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        let finalGroups = {
          Groups: [],
          GroupItems: []
        };

        if(featureIDs?.length < 1)
        {
          return new Promise((resolve,reject) => {
            resolve(finalGroups);
          });
        }


        let allGroupItemResults = [];
        const numberToTakeEachTime = 2000;
        let startIndex = 0;
        let hasMoreRecords = true;
        let results = "";

        while(hasMoreRecords){
          try{
            let endIndex = startIndex + numberToTakeEachTime;
            let entityIdBatch = [];
            entityIdBatch = featureIDs.slice(startIndex, endIndex);
            let entityIdBatchStr = entityIdBatch.join(",");
            let batchWhere = `(${FieldNames.treatmentActivityGroupItems.joinID} IN (${entityIdBatchStr}) AND (${FieldNames.treatmentActivityGroupItems.joinFeature} = '${joinFeature}'))`;
  
            const queryObject = new Query({
              where: batchWhere,
              orderByFields: "OBJECTID DESC",
              outFields: "*",
              returnGeometry: false,
              num:numberToTakeEachTime
            });

            results = await GeneralService.queryCall(rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId, queryObject);
            if(results && results.length > 0){
              allGroupItemResults.push(results)
            }
          } catch(e){
            throw e;
          }
          hasMoreRecords = featureIDs.length > (startIndex + numberToTakeEachTime);
          startIndex += numberToTakeEachTime;
        }

        const allGroupItemResultsFlattened = (allGroupItemResults != null && allGroupItemResults.length > 0) ? allGroupItemResults.flat() : [];
        if(allGroupItemResultsFlattened &&
          allGroupItemResultsFlattened.length && allGroupItemResultsFlattened.length > 0)
        {
          let groupItems = allGroupItemResultsFlattened;
          let groupIds = allGroupItemResultsFlattened.map((eaGroupItem) => eaGroupItem[FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID]);
          let allGroupResults = [];
          startIndex = 0;
          hasMoreRecords = true;
          results = "";
  
          if(groupIds && groupIds.length)
          {
            while(hasMoreRecords){
              try{
                let endIndex = startIndex + numberToTakeEachTime;
                let groupIdBatch = [];
                groupIdBatch = groupIds.slice(startIndex, endIndex);
                let groupIdBatchStr = "" + groupIdBatch.join(",") + "";
                let groupBatchWhere = `(ID IN (` + groupIdBatchStr + "))";
      
                const groupQueryObject = new Query({
                  where: groupBatchWhere,
                  outFields: "*",
                  orderByFields: "OBJECTID DESC",
                  returnGeometry: false,
                  num:numberToTakeEachTime
                });
    
                results = await GeneralService.queryCall(rootServiceUrl + "/" + config.treatmentActivityGroup[config.env].layerId, groupQueryObject);
  
                if(results && results.length > 0){
                  allGroupResults.push(results)
                }
              } catch(e){
                throw e;
              }
              hasMoreRecords = groupIds.length > (startIndex + numberToTakeEachTime);
              startIndex += numberToTakeEachTime;
            }
  
            const allGroupResultsFlattened = (allGroupResults != null && allGroupResults.length > 0) ? allGroupResults.flat() : [];
            if(allGroupResultsFlattened && allGroupResultsFlattened.length > 0){
              const groups = allGroupResultsFlattened;
              let globalIds = [];
              if(groups && groups.length > 0){
                globalIds = groups.map((eaAttr) => eaAttr[FieldNames.treatmentActivityGroups.id]);
              }
              let remainingGroupItems = [];
              if(globalIds && groupItems){
                remainingGroupItems = groupItems.filter(x => globalIds.includes(x[FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID]));
              }
              finalGroups.Groups = groups;
              finalGroups.GroupItems = remainingGroupItems;
              return finalGroups;
            } else {
              return finalGroups;
            }
          }
          else
          {
            return finalGroups;
          }
        }
        else
        {
          return finalGroups;
        }
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    getGroupsByIDs: function (groupIds) 
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        let whereArray = [];
        groupIds.forEach((groupId) => {
          whereArray.push("(ID = '" + groupId + "')");
        })
        const whereClause = whereArray.join(" OR ");
        const queryObject = new Query({
            where: `(${whereClause})`,
            outFields: "*"
        });

        return query.executeQueryJSON(rootServiceUrl + "/" + config.treatmentActivityGroup[config.env].layerId, queryObject).then(results => {
          let attr;
          if(results.features){
            attr = results.features.map((eaAttr) => eaAttr.attributes);
          }
          return attr;
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    }, 
    createGroup: function (groupItems, groupName, userInfo) 
    {   
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        //TODO: Move hardcodes into configs
        let attributes = {};
        attributes[FieldNames.treatmentActivityGroups.treatmentActivityGroupName] = groupName;
        attributes[FieldNames.treatmentActivityGroups.isArchived] = FieldNames.yesNo.no;
        attributes[FieldNames.treatmentActivityGroups.createdBy] = userInfo[FieldNames.userFields.nifcUsername];
        attributes[FieldNames.treatmentActivityGroups.createdDate] = getSaveableDate(new Date());

        const newGroup = 
        {
            attributes:attributes
        }
        return new Promise((resolve, reject) => {
            new Request().makeRequest({
                url: rootServiceUrl + "/" + config.treatmentActivityGroup[config.env].layerId + '/addFeatures',
                method: 'post',
                data: {
                    f: 'json',
                    token: nifcToken,
                    features: JSON.stringify([newGroup])
                }
            }).then(
                resp => {
                  if (resp?.addResults[0]?.success) {
                    IDService.getGroupID(resp.addResults[0].objectId).then(async idVal => {
                      var i = 0;
                      let allGroupItemsToAdd = [];
                      groupItems.forEach(groupItemFeature => {  
                          //TODO: Move hardcodes into configs
                        let itemAttributes = {};
                        itemAttributes[FieldNames.treatmentActivityGroupItems.isArchived] = FieldNames.yesNo.no;
                        itemAttributes[FieldNames.treatmentActivityGroupItems.treatmentActivityGroupID] = resp?.addResults[0].globalId;
                        itemAttributes[FieldNames.treatmentActivityGroupItems.joinID] = groupItemFeature[FieldNames.featureFields.joinID];
                        itemAttributes[FieldNames.treatmentActivityGroupItems.joinFeature] = groupItemFeature[FieldNames.featureFields.joinFeature];
                        itemAttributes[FieldNames.treatmentActivityGroupItems.entityID] = `${groupItemFeature[FieldNames.featureFields.objectID]}`;
                        itemAttributes[FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID] = idVal;
                        itemAttributes[FieldNames.treatmentActivityGroupItems.createdBy] = userInfo[FieldNames.userFields.nifcUsername];
                        itemAttributes[FieldNames.treatmentActivityGroupItems.createdDate] = getSaveableDate(new Date());
                        itemAttributes[FieldNames.treatmentActivityGroupItems.entityType] = groupItemFeature[FieldNames.treatmentActivityGroupItems.entityType];
                        itemAttributes[FieldNames.treatmentActivityGroupItems.sequenceNumber] = i + 1;
                        allGroupItemsToAdd.push(itemAttributes);
                        i++;
                      });
                      const itemsSaved = await this.addItemsForGroup(allGroupItemsToAdd);
                      resolve(resp)
                    })
                  }
                    
                },
                error => {
                  reject(error)
                }
            );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }   
    },
    updateGroupName: function (groupObjectID, groupName)
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        let attributes = {}
        attributes[FieldNames.treatmentActivityGroups.objectID] = groupObjectID;
        attributes[FieldNames.treatmentActivityGroups.treatmentActivityGroupName] = groupName;
        const group = 
        {
            attributes: attributes
        }
  
        return new Promise((resolve, reject) => {
          new Request().makeRequest({
            url: rootServiceUrl + "/" + config.treatmentActivityGroup[config.env].layerId + '/updateFeatures',
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                features: JSON.stringify([group])
            }
          }).then(
            resp => {
              resolve(resp)
            },
            error => {
              reject(error)
            });
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    archiveGroups: function (groups) 
    { 
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        return new Promise((resolve, reject) => {
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.treatmentActivityGroup[config.env].layerId + '/updateFeatures',
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  features: JSON.stringify(groups)
              }
          }).then(
              resp => {
                  resolve(resp)
              },
              error => {
                reject(error)
              }
          );    
      });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }  
    },
    archiveGroupItems: function (groupItems) 
    {  
      try
      {
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const nifcToken = getNifcToken();

        return new Promise((resolve, reject) => {

          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId + '/updateFeatures',
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  features: JSON.stringify(groupItems)
              }
          }).then(
              resp => {
                  resolve(resp)
              },
              error => {
                reject(error)
              }
          );
          
      });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      } 
    },
    updateItemForGroup: function (treatmentActivityGroupItems) 
    {   
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        return new Promise((resolve, reject) => {
          new Request().makeRequest({
            url: rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId + '/updateFeatures',
            method: 'post',
            data: {
              f: 'json',
              token: nifcToken,
              features: JSON.stringify(treatmentActivityGroupItems)
            }
          }).then(
              resp => {
                resolve(resp);
              },
              error => {
                reject(error)
              }
          );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    deleteItemsFromGroup: function(objectIds, groupId)
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        return new Promise((resolve, reject) => {
          let whereArray = [];
          let whereClause = '';
          if(objectIds && objectIds.length > 0){
            objectIds.forEach((objectId) => {
              whereArray.push(`OBJECTID = ${objectId}`);
            })
          }
          if(whereArray && whereArray.length > 0){
            whereClause = whereArray.join(" OR ");
            const finalWhereClause = `${FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID} = ${groupId} AND (${whereClause})`;
            new Request().makeRequest({
                url: rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId + '/deleteFeatures',
                method: 'post',
                data: {
                    f: 'json',
                    token: nifcToken,
                    where: finalWhereClause
                }
            }).then(
                resp => {
                    resolve(resp);
                },
                error => {
                  reject(error)
                }
            );
          } else {
            resolve([]);
          }
  
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    // TODO: Weirdly this one is unused. Feels like one that should be used somewhere?
    deleteItemFromGroup: function(objectId, groupId)
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        return new Promise((resolve, reject) => {
          const finalWhereClause = `((${FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID} = ${groupId}) AND (OBJECTID = ${objectId}))`;
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId + '/deleteFeatures',
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  where: finalWhereClause
              }
          }).then(
              resp => {
                  resolve(resp);
              },
              error => {
                reject(error)
              }
          );
  
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    deleteAllItemsFromGroup: function(groupId)
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        return new Promise((resolve, reject) => {
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId + '/deleteFeatures',
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  where: `(${FieldNames.treatmentActivityGroupItems.treatmentActivityGroupJoinID} = ${groupId})`
              }
          }).then(
              resp => {
                  resolve(resp);
              },
              error => {
                reject(error)
              }
          );
  
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    deleteGroup: function(groupId)
    {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        return new Promise((resolve, reject) => {
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.treatmentActivityGroup[config.env].layerId + '/deleteFeatures',
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  where: `${FieldNames.treatmentActivityGroups.id} = ${groupId}`
              }
          }).then(
              resp => {
                  resolve(resp);
              },
              error => {
                reject(error)
              }
          );
  
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    addItemsForGroup: function (treatmentActivityGroupItems) 
    {   
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const nifcToken = getNifcToken();
        let model = this;
        let allFinalResults = [];
  
        return new Promise(async (resolve, reject) => {
          let allItems = [];
          treatmentActivityGroupItems.forEach(item => {
            const groupItem = 
            { 
                attributes: item
            };
            allItems.push(groupItem)
          })
          let url = rootServiceUrl + "/" + config.treatmentActivityGroupItems[config.env].layerId;
          const numberToTakeEachTime = 500;
          let startCount = 0;
          let hasMoreRecords = true;
          let finalResults = "";
          while(hasMoreRecords){
            const numberToTake = ((startCount + numberToTakeEachTime) > allItems.length) ? allItems.length - startCount : numberToTakeEachTime;
            let numbersToRun = allItems.slice(startCount, numberToTake + startCount);
            try{
              finalResults = await model.addCallForMultipleGroupItems(url, numbersToRun);
              if(finalResults && finalResults.addResults){
                allFinalResults.push(finalResults.addResults)
              }
            } catch(e){
              numbersToRun.forEach(item => {
                const newItem = {
                  objectId: item.attributes[FieldNames.featureFields.objectID],
                  success: false
                }
                allFinalResults.push(newItem)
              })
            }
            hasMoreRecords = allItems.length > (startCount + numberToTakeEachTime);
            startCount += numberToTakeEachTime;
          }
  
          let failedItems = [];
          let successfulItems = [];
          if(!hasMoreRecords){
            allFinalResults.flat().forEach(result => {
              if(result){
                if(!result.success){
                  failedItems.push(result.objectId);
                } else {
                  successfulItems.push(result.objectId);
                }
              }
            })
          }
  
          const allItemResults = {
            successful: successfulItems,
            failures: failedItems
          }
          resolve(allItemResults);
        })
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    addCallForMultipleGroupItems: function(url, allItems){
      try
      {
        const nifcToken = getNifcToken();
        return new Promise((resolve, reject) => {
          new Request().makeRequest({
              url: url + '/addFeatures',
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken, 
                  features: JSON.stringify(allItems)
              }
          }).then(
              resp => {
                  resolve(resp);
              },
              error => {
                reject(error)
              }
          );
      });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    }
};

export default GroupingService;
